import { render } from "./users_component.vue?vue&type=template&id=6645ca0a&scoped=true"
import script from "./users_component.vue?vue&type=script&lang=js"
export * from "./users_component.vue?vue&type=script&lang=js"

import "./users_component.vue?vue&type=style&index=0&id=6645ca0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6645ca0a"]])

export default __exports__